// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { headerText } from "@vanmeter/App/SharedStyles/AutoCompleteSharedStyles";
import { autocompleteProductsStyles } from "@vanmeter/Overrides/Widgets/Header/AutocompleteProducts";
import { fontConfig } from "@vanmeter/XDL/constants";
import IconPaginationArrowRight from "@vanmeter/XDL/Icons/IconPaginationArrowRight";
import { color, mergeWithCss } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

autocompleteProductsStyles.header = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 20px;
    `,
};

autocompleteProductsStyles.headerText = headerText;

autocompleteProductsStyles.headerLink = {
    typographyProps: { ...fontConfig.xSmallSingleLine },
    icon: { iconProps: { src: IconPaginationArrowRight, size: 12 }, position: "right" },
};

autocompleteProductsStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 72px 1fr;
        gap: 12px;
        width: 100%;
        &:not(:last-of-type) {
            padding-bottom: 12px;
            margin-bottom: 12px;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};

autocompleteProductsStyles.focusedContainer = {
    ...mergeWithCss(autocompleteProductsStyles.container, {
        css: css`
            background: ${color("common.ui3")};
        `,
    }),
};

autocompleteProductsStyles.productsContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr;
        width: 100%;
    `,
};

autocompleteProductsStyles.imageClickable = {
    css: css`
        height: fit-content;
    `,
};

autocompleteProductsStyles.image = {
    width: "72px",
    css: css`
        grid-column: 1/2;
        grid-row: 1/3;
        img {
            height: auto;
            max-width: 100%;
            max-height: 100%;
            aspect-ratio: 1;
        }
    `,
};
autocompleteProductsStyles.productDescription = {
    css: css`
        grid-column: 2/3;
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};

autocompleteProductsStyles.actionsWrapper = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 2 / 3;
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

autocompleteProductsStyles.productTitle = {
    productDetailLink: {
        css: css`
            min-height: unset;
        `,
    },
    productDetailDescription: {
        css: css`
            min-height: unset;
        `,
    },
    productDetailSubDescription: {
        css: css`
            min-height: unset;
        `,
    },
};

autocompleteProductsStyles.erpNumberText = {
    css: css`
        display: flex;
        column-gap: 4px;
    `,
};

autocompleteProductsStyles.actions = {
    productAddToCartButtonStyles: {
        css: css`
            max-width: 198px;
        `,
    },
};
